/*********************** Custom JS for Boost AI Search & Discovery  ************************/
/* Mobile header search uses the theme drawer + Boost PFS (eagle-mobile-search.liquid). */
/* Desktop header search uses the theme popup + Boost PFS (theme.js). */

(function () {
  if (window.__eagleBoostSdCartDisabled) {
    return;
  }
  window.__eagleBoostSdCartDisabled = true;

  function isBoostSdCartModal(node) {
    return (
      node &&
      node.classList &&
      node.classList.contains('boost-sd__modal') &&
      node.querySelector('.boost-sd__cart')
    );
  }

  function closeBoostSdCart() {
    document.querySelectorAll('.boost-sd__modal').forEach(function (modal) {
      if (!modal.querySelector('.boost-sd__cart')) {
        return;
      }

      modal.style.display = 'none';
      modal.style.visibility = 'hidden';
      modal.style.pointerEvents = 'none';
      modal.setAttribute('aria-hidden', 'true');
      modal.removeAttribute('aria-modal');
    });
  }

  window.eagleCloseBoostSdCart = closeBoostSdCart;

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest && event.target.closest('[data-cart-sidebar]')) {
        closeBoostSdCart();
        window.setTimeout(closeBoostSdCart, 0);
        window.setTimeout(closeBoostSdCart, 50);
        window.setTimeout(closeBoostSdCart, 200);
        window.setTimeout(closeBoostSdCart, 400);
      }
    },
    true
  );

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      var target = mutation.target;

      if (isBoostSdCartModal(target)) {
        if (
          target.getAttribute('aria-modal') === 'true' ||
          target.style.display === 'block' ||
          target.style.visibility === 'visible'
        ) {
          closeBoostSdCart();
        }
        return;
      }

      if (
        mutation.type === 'childList' &&
        mutation.addedNodes &&
        mutation.addedNodes.length
      ) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) {
            return;
          }

          if (isBoostSdCartModal(node) || (node.querySelector && node.querySelector('.boost-sd__cart'))) {
            closeBoostSdCart();
          }
        });
      }
    });
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'aria-modal', 'aria-hidden']
  });
})();
